export default __webpack_public_path__ + "static/media/upprovall-plus-beta-no-price.47601c47.webp";